<template>
  <BaseCardV2
    :erreur="erreurAdherent || erreurGroupe"
    :has-btn-action="false"
    class="pa-2"
    has-help
    titre="Répartition des ventes"
    @on-help="isOpenModalHelp = true"
  >
    <div
      class="mb-2"
    >
      <div class="ml-3 my-2 texte texte-gris-fonce">
        Mon exploitation
      </div>
      <BaseLoader v-if="loadingAdherent" />
      <div
        v-else-if="hasDonneeAdherent"
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'mr-1'"
        class="d-flex justify-space-around mt-4"
      >
        <BaseDoughnutChartV2
          :chart-data="chartDataAdherent"
          class="align-self-center "
        />

        <div class="align-self-center">
          <div
            v-if="hasDonneeAdherentPrixFerme"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsNumtiers[0]"
              class="mr-2"
              label
            >
              <span class="white--text mr-1">{{ repartitionQuantiteCibleAdherent.quantiteContractualiseePrixFermeEnPourcentage * 100 | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Prix ferme</span>
          </div>
          <div
            v-if="hasDonneeAdherentGestionDeleguee"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsNumtiers[1]"
              class="mr-2"
              label
            >
              <span class="white--text mr-1">{{ repartitionQuantiteCibleAdherent.quantiteContractualiseeGestionDelegueeEnPourcentage * 100 | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Gestion déléguée</span>
          </div>
          <div
            v-if="hasDonneeAdherentAutres"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsNumtiers[2]"
              class="mr-2"
              label
            >
              <span class="white--text mr-1">{{ repartitionQuantiteCibleAdherent.quantiteContractualiseeAutresContratsEnPourcentage * 100 | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Autres</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
          class="d-flex align-center flex-column"
        >
          <img
            alt="no-contrats"
            src="@/assets/no-contrats.svg"
          >
          <div
            :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
            class=" d-flex flex-column intro texte-gris-fonce text-align-center mt-2"
          >
            <span>Vous n'avez pas de contrat</span>
          </div>
        </div>
      </div>
      <BaseLoader v-if="!loadingAdherent && loadingGroupe" />
      <div
        v-else-if="!loadingGroupe && hasDonneeGroupe && hasRegionSelected"
        class="ml-3 mt-8 my-2 texte texte-gris-fonce"
      >
        Mon groupe ({{ repartitionQuantiteCibleGroupe.nbAdherents }} adhérent{{ repartitionQuantiteCibleGroupe.nbAdherents > 1 ? 's' : '' }})
      </div>
      <div
        v-if="(!hasDonneeGroupe && !loadingGroupe) || !hasRegionSelected"
        class="ml-3 mt-8 my-2 texte texte-gris-fonce"
      >
        <BaseMessageV2 message="Nombre d'adhérents insuffisant pour la comparaison (&lt; 1 adhérent)" />
      </div>
      <div
        v-if="!loadingGroupe && hasDonneeGroupe && hasRegionSelected"
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'mr-1'"
        class="d-flex justify-space-around mt-4"
      >
        <BaseDoughnutChartV2
          :chart-data="chartDataGroupe"
          class="align-self-center "
        />

        <div class="align-self-center">
          <div
            v-if="hasDonneeGroupePrixFerme"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsGroupe[0]"
              class="mr-2"
              label
            >
              <span class="white--text">{{ repartitionQuantiteCibleGroupe.quantiteContractualiseePrixFermeEnPourcentage * 100 | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Prix ferme</span>
          </div>
          <div
            v-if="hasDonneeGroupeGestionDeleguee"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsGroupe[1]"
              class="mr-2"
              label
            >
              <span class="secondary--text">{{ repartitionQuantiteCibleGroupe.quantiteContractualiseeGestionDelegueeEnPourcentage * 100 | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Gestion déléguée</span>
          </div>
          <div
            v-if="hasDonneeGroupeAutres"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsGroupe[2]"
              class="mr-2"
              label
            >
              <span class="secondary--text">{{ repartitionQuantiteCibleGroupe.quantiteContractualiseeAutresContratsEnPourcentage * 100 | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Autres</span>
          </div>
        </div>
      </div>

      <HelpModal
        v-if="isOpenModalHelp"
        titre="Répartition des ventes"
        :is-open-modal-help="isOpenModalHelp"
        @close="isOpenModalHelp = false"
      >
        <div slot="baseCardHelpContent">
          <div class="texte text-justify texte-gris-fonce pa-8">
            <p>Certains contrats ont été regroupés pour plus de lisibilité. Voici ce que chaque intitulé contient :</p>
            <li class="pb-2">
              <span class="black--text">Gestion déléguée :</span> Prix de campagne et prix par période (septembre-avril, novembre-mai et quinto).
            </li>
            <li class="pb-2">
              <span class="black--text">Prix ferme :</span> Terme moisson, prix de marché, tréso moisson et matif
            </li>
            <li><span class="black--text">Autres :</span> Echange céréales semences, échange céréales aliments et contrats filière</li>
          </div>
        </div>
      </HelpModal>
    </div>
  </BaseCardV2>
</template>

<script>
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseDoughnutChartV2 from '@/components/chart/base-doughnut-chart-v2.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import {mapGetters} from 'vuex'
import numberFilter from '@/filters/number.filter'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageV2 from '@/components/common/base-message-v2.vue'

export default {
  name: 'RepartitionVentes',
  components: {BaseLoader, BaseCardV2, BaseDoughnutChartV2, BaseMessageV2, HelpModal },
  props: {
    loadingAdherent: {
      type: Boolean,
      default: null
    },
    loadingGroupe: {
      type: Boolean,
      default: null
    },
    erreurAdherent: {
      type: Boolean,
      default: null
    },
    erreurGroupe: {
      type: Boolean,
      default: null
    },
    hasRegionSelected: {
      type: Boolean,
      default: null
    },
  },
  data () {
    return {
      isOpenModalHelp: false,
      colorsNumtiers: ['#027F5F', '#74B335', '#A5C923'],
      colorsGroupe :['#64AB3B', '#B5D11D', '#E6E70B']
    }
  },

  computed: {
    ...mapGetters({
      repartitionQuantiteCibleAdherent: 'contrat/repartitionQuantiteCibleAdherent',
      repartitionQuantiteCibleGroupe: 'contrat/repartitionQuantiteCibleGroupe',
      filtresAdherent: 'filtresComparaison/filtresAdherent'
    }),
    valuesAdherent () {
      return [
        this.repartitionQuantiteCibleAdherent.quantiteContractualiseePrixFermeEnPourcentage,
        this.repartitionQuantiteCibleAdherent.quantiteContractualiseeGestionDelegueeEnPourcentage,
        this.repartitionQuantiteCibleAdherent.quantiteContractualiseeAutresContratsEnPourcentage,
      ]
    },
    valuesGroupe () {
      return [
        this.repartitionQuantiteCibleGroupe.quantiteContractualiseePrixFermeEnPourcentage,
        this.repartitionQuantiteCibleGroupe.quantiteContractualiseeGestionDelegueeEnPourcentage,
        this.repartitionQuantiteCibleGroupe.quantiteContractualiseeAutresContratsEnPourcentage,
      ]
    },
    chartDataAdherent () {
      return {
        id: 'chartDataAdherent',
        labels: ['Prix ferme', 'Gestion déléguée', 'Autres'],
        datasets: [
          {
            legendTooltip: {
              title: 'ventes',
              value: this.valuesAdherent.map(r => numberFilter.formatNumber(r * 100, 2)),
              unit: '%'
            },
            backgroundColor: this.colorsNumtiers,
            data: this.valuesAdherent
          }
        ]
      }
    },
    chartDataGroupe () {
      return {
        id: 'chartDataGroupe',
        labels: ['Prix ferme', 'Gestion déléguée', 'Autres'],
        datasets: [
          {
            legendTooltip: {
              title: 'ventes',
              value: this.valuesGroupe.map(r=> numberFilter.formatNumber(r * 100, 2)),
              unit: '%'
            },
            backgroundColor: this.colorsGroupe,
            data: this.valuesGroupe
          }
        ]
      }
    },
    hasDonneeAdherentPrixFerme () {
      return !!this.repartitionQuantiteCibleAdherent?.quantiteContractualiseePrixFermeEnPourcentage
    },
    hasDonneeAdherentGestionDeleguee () {
      return !!this.repartitionQuantiteCibleAdherent?.quantiteContractualiseeGestionDelegueeEnPourcentage
    },
    hasDonneeAdherentAutres () {
      return !!this.repartitionQuantiteCibleAdherent?.quantiteContractualiseeAutresContratsEnPourcentage
    },
    hasDonneeAdherent () {
      return this.hasDonneeAdherentPrixFerme || this.hasDonneeAdherentGestionDeleguee || this.hasDonneeAdherentAutres
    },
    hasDonneeGroupePrixFerme () {
      return !!this.repartitionQuantiteCibleGroupe?.quantiteContractualiseePrixFermeEnPourcentage
    },
    hasDonneeGroupeGestionDeleguee () {
      return !!this.repartitionQuantiteCibleGroupe?.quantiteContractualiseeGestionDelegueeEnPourcentage
    },
    hasDonneeGroupeAutres () {
      return !!this.repartitionQuantiteCibleGroupe?.quantiteContractualiseeAutresContratsEnPourcentage
    },
    hasDonneeGroupe () {
      return this.repartitionQuantiteCibleGroupe.nbAdherents > 0 &&
        (this.hasDonneeGroupePrixFerme || this.hasDonneeGroupeGestionDeleguee || this.hasDonneeGroupeAutres)
    }
  }
}

</script>

<style lang="scss" scoped>
.jauge {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.opacity {
  opacity: 0.2;
  zoom: 75%;
}
</style>
